import type * as lazyIndex from './lazyIndex';
import type { OutlookInlineTipsWithPopoverProps } from './components/OutlookInlineTipsWithPopover';
import type { OutlookTeachingBubbleProps } from './components/OutlookTeachingBubble';
import { createLazyComponent, type LazyComponent, LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "LightningViews" */ './lazyIndex'),
    { name: 'LightningViews' }
);

export const OutlookTeachingBubble: LazyComponent<OutlookTeachingBubbleProps, unknown> =
    createLazyComponent(lazyModule, m => m.OutlookTeachingBubble);

export const OutlookInlineTipsWithPopover: LazyComponent<
    OutlookInlineTipsWithPopoverProps,
    unknown
> = createLazyComponent(lazyModule, m => m.OutlookInlineTipsWithPopover);

export const lazyLoadLightningPrimaryViewDialog: LazyAction<
    typeof lazyIndex.loadLightningPrimaryViewDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadLightningPrimaryViewDialog);

export const lazyOnDemandFREDialog: LazyAction<
    typeof lazyIndex.onDemandFREDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onDemandFREDialog);

export type { OutlookInlineTipsStyle } from './components/OutlookInlineTips';
export type {
    FREScreenConfig,
    FREExperienceConfig,
    FREControls,
} from './components/types/FRETypes';
